// @ts-check
// Célula de planilha que começa com =, +, -, @, tab ou retorno vira fórmula no Excel e no LibreOffice (injeção de
// fórmula). O apóstrofo na frente faz a planilha mostrar o texto como está. Número puro ("-12,5") continua número.

const FORMULA_START = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^[+-]?\d+(?:[.,]\d+)*$/;

/**
 * @param {string} text
 * @returns {string}
 */
export function neutralizeCsvFormula(text) {
  return FORMULA_START.test(text) && !PLAIN_NUMBER.test(text) ? `'${text}` : text;
}
